<div class="container-fluid">
  @for (item of itemCollection; track item; let i = $index) {
    <app-display-card
      [isSelected]="isSelected(item)"
      [panelStyle]="cardStyle"
      [panelHeight]="displayCardPanelHeight"
      class="row row-padding"
    >
      <ng-template
        [ngTemplateOutlet]="templateRef"
        [ngTemplateOutletContext]="{ item, index: i }"
      ></ng-template>
    </app-display-card>
  }
</div>
